<div class="page-inner-body portlet light">
  <div class="portlet-body">
    <div class="table-toolbar mb-4">
      <div class="row">
        <div class="col-md-12">
          <p-toolbar styleClass="bg-white">
            <div class="p-toolbar-group-start">
              <div class="d-flex flex-column justify-content-start align-items-start">
                <div class="d-flex align-items-center fs-5 fw-bold">
                  {{ 'wix.manageWixConnectionsHere' | transloco }}
                </div>
              </div>
            </div>
          </p-toolbar>
        </div>
      </div>
    </div>
    <!-- Overlay Panel for Wix Disconnect -->
    <p-overlayPanel #wixMenuPanel>
      <div class="px-2 py-2 small text-start">
        <div class="mb-2 text-muted fw-semibold">{{ 'wix.manageWixConnection' | transloco }}</div>

        <button pButton type="button"
          class="p-button p-button-danger p-button-sm w-100 justify-content-center text-center"
          (click)="onDisconnectWixAccount(); wixMenuPanel.hide()">
          {{ 'wix.disconnectAccount' | transloco }}
        </button>

        <div class="text-muted mt-3 small">
          {{ 'wix.disconnectingWillLabel' | transloco }}
          <ul class="mt-1 ps-3">
            <li>{{ 'wix.unlinkWebsite' | transloco }}</li>
            <li>{{ 'wix.stopFutureSyncs' | transloco }}</li>
            <li>{{ 'wix.disableAutoUpdates' | transloco }}</li>
            <li>{{ 'wix.reconnectLater' | transloco }}</li>
          </ul>
          {{ 'wix.confirmBeforeProceeding' | transloco }}
        </div>
      </div>
    </p-overlayPanel>

    <!-- Wix Account Section -->
    <div class="mt-4">
      <div class="row">
        @if (wixSiteDetail) {
          <div class="col-12 col-md-6 mb-3">
            <div class="card shadow-sm border-0 rounded-4 overflow-hidden h-100 bg-light-subtle position-relative">
              <div class="card-body p-4">
                <!-- Title -->
                <div class="fs-5 text-dark-emphasis mb-1">
                  {{ wixSiteDetail.WixSiteProperties.siteDisplayName }}
                </div>
                <div class="text-muted small mb-3">
                  {{ wixSiteDetail.WixSiteProperties.locale.languageCode }} - {{
                  wixSiteDetail.WixSiteProperties.locale.country }}
                </div>
                <!-- Info -->
                <div class="d-grid gap-2 small text-body-secondary">
                  <div>
                    {{ 'wix.storeUrl' | transloco }}
                    <a [href]="wixSiteDetail.WixSiteInfo.url" target="_blank">
                      {{ wixSiteDetail.WixSiteInfo.url }}
                    </a>
                  </div>
                  <div>{{ 'wix.paymentCurrency' | transloco }} {{ wixSiteDetail.WixSiteProperties.paymentCurrency }}</div>
                  <div>{{ 'wix.timeZone' | transloco }} {{ wixSiteDetail.WixSiteProperties.timeZone }}</div>
                  <div>{{ 'wix.businessConfig' | transloco }} {{ wixSiteDetail.WixSiteProperties.businessConfig }}</div>
                  <div>{{ 'wix.connectedOn' | transloco }} {{ wixSiteDetail.WisSiteConnectedAt | date: 'dd/MM/yyyy' }}</div>
                </div>
              </div>
              <!-- 3-dot button for menu -->
              <div class="position-absolute end-0 top-0 p-2">
                <button class="btn btn-light btn-sm rounded-circle" (click)="wixMenuPanel.toggle($event)">
                  •••
                </button>
              </div>
            </div>
          </div>
        }
      </div>

      <!-- Empty State -->
      @if (!wixSiteDetail) {
        <div class="text-center mt-4">
          <button pButton type="button" class="p-button p-button-outlined p-button-sm fw-semibold shadow-sm"
            (click)="connectWithWixAccount()">
            {{ 'wix.connectWixAccount' | transloco }}
          </button>
          <div class="text-muted mt-2 small">
            {{ 'wix.noWixAccountConnected' | transloco }}
          </div>
        </div>
      }
    </div>

  </div>
</div>


<p-dialog [header]="'wix.wixAccountConnectionSuccess' | transloco" [(visible)]="isConnectWixSuccessDialogVisible" [modal]="true"
  (onHide)="closeWixConnectionSuccessDialog()" [style]="{ 'width': '430px'}">
  <div class="d-flex flex-column align-items-center px-3 py-3 text-center">
    <img src="assets/images/tik-image.jpg" alt="Success" class="img-fluid rounded-circle" style="width: 100px;">
    <div class="h5 mt-4 text-secondary">
      {{ 'wix.wixAccountConnectedSuccessfully' | transloco }}
    </div>
    <div class="text-secondary">
      {{ 'wix.wixConnectedSyncEnabled' | transloco }}
    </div>
  </div>
</p-dialog>